<template>
  <div
    id="contact"
    class="pt-10"
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="500"
  >
    <Title text="Contact" />
    <p class="font-AvenirFont text-lg text-gray-700 mt-3">
      For more information, contact
      <a
        href="mailto: media@shottracker.com"
        class="text-STorange hover:text-STblue hover:underline"
        >media@shottracker.com</a
      >.
    </p>
  </div>
</template>

<script>
import Title from "./Title.vue";
export default {
  name: "Contact",

  components: {
    Title,
  },
};
</script>

